
import React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import ScrollReveal from "@/components/ui/scroll-reveal";
import { useTranslation } from "@/hooks/useTranslation";

const HowItWorks = () => {
  const { t } = useTranslation();

  const steps = [
    {
      number: "01",
      title: t("howItWorks.steps.step1.title"),
      description: t("howItWorks.steps.step1.desc")
    },
    {
      number: "02",
      title: t("howItWorks.steps.step2.title"),
      description: t("howItWorks.steps.step2.desc")
    },
    {
      number: "03",
      title: t("howItWorks.steps.step3.title"),
      description: t("howItWorks.steps.step3.desc")
    },
    {
      number: "04",
      title: t("howItWorks.steps.step4.title"),
      description: t("howItWorks.steps.step4.desc")
    }
  ];

  return (
    <section className="section-padding">
      <div className="container mx-auto px-4">
        <ScrollReveal>
          <div className="text-center max-w-3xl mx-auto mb-16">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">
              {t("howItWorks.title")}
            </h2>
            <p className="text-lg text-gray-600">
              {t("howItWorks.subtitle")}
            </p>
          </div>
        </ScrollReveal>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-16">
          {steps.map((step, index) => (
            <ScrollReveal key={index} delay={index * 100}>
              <div className="relative pl-16">
                <div className="absolute left-0 top-0 w-10 h-10 rounded-full bg-brand-100 flex items-center justify-center text-brand-700 font-semibold">
                  {step.number}
                </div>
                <h3 className="text-xl font-semibold mb-3">{step.title}</h3>
                <p className="text-gray-600">{step.description}</p>
              </div>
            </ScrollReveal>
          ))}
        </div>

        <ScrollReveal delay={400}>
          <div className="bg-brand-50 border border-brand-100 rounded-xl p-8 md:p-12">
            <div className="flex flex-col md:flex-row md:items-center justify-between">
              <div className="mb-6 md:mb-0 md:mr-8">
                <h3 className="text-2xl font-bold mb-3">
                  {t("howItWorks.cta.title")}
                </h3>
                <p className="text-gray-700">
                  {t("howItWorks.cta.subtitle")}
                </p>
              </div>
              <Link to="/demo">
                <Button size="lg" className="gradient-bg whitespace-nowrap">
                  {t("howItWorks.cta.button")}
                </Button>
              </Link>
            </div>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
};

export default HowItWorks;
